import React from "react";
import { Button } from "../../UI/Button";
import { Grid } from "../../UI/Grid";

import { MODES } from "./constants";

export const ModeSwitch = ({ mode, onChange }) => (
  <Grid container>
    <Grid item>
      <Button isSelected={mode !== MODES.EDIT} onClick={() => onChange(MODES.PREVIEW)}>
        Preview
      </Button>
    </Grid>
    <Grid item>
      <Button isSelected={mode === MODES.EDIT} onClick={() => onChange(MODES.EDIT)}>
        View HTML
      </Button>
    </Grid>
  </Grid>
);
